<template>
    <div>
        <div class="loader" v-if="!schemaLoaded">

        </div>
        <details-grid v-else
                      :schemaModel="schemaModel"
                      :columns="columns"
                      :registerName="registerName"
                      :showHideButton="showHideButton"
                      :showPinButton="showPinButton"
                      :showNewButton="showNewButton"
                      :showResizeIcon="showResizeIcon"
                      :showSettingsBtn="showSettingsBtn"
                      :showImportFromExcelButton="true"
                      :size="size"
                      :showBtns="showBtns"
                      :titleKey="titleKey"
                      @resize="resize"
                      @hide="hide"
                      @pinned="pinned"
                      @unpinned="unpinned"
                      @archive="archive">
        </details-grid>

        <!--<br />
        <component v-if="showStatuses" :is="registerName"></component>-->
    </div>
</template>

<script>
    import DynamicRegisterDetailsGrid from "../../../components/dynamic/view/DetailsGrid";
    export default {
        name: 'list-dynamic-data',
        components: {
            'details-grid': DynamicRegisterDetailsGrid,
        },
        props: {
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            registerName: {
                default: '',
                type: String
            },
            dateFormat: {
                default: 'dd-MM-yyyy HH:mm:ss',
                type: String
            },
            showStatuses: {
                default: true,
                type: Boolean
            },
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                schemaLoaded: false,
                schemaModel: {},
                columns: [],
                dateFields: [],
                titleKey: 'registers.' + this.registerName + '.title', // Трабва на конпонентата за бутоните за дашборд настройките
            };
        },
        methods: {
            loadSchema() {
                this.$http.get(`/api/dynamicRegisters/datamodel/`, { params: { registerName: this.registerName } }
                ).then((response) => {
                    if (Array.isArray(response.data.items) && response.data.items.length > 0) {
                        let sampleDataItem = response.data.items[0];
                        let captions = response.data.captions

                        this.schemaModel = this.generateModel(sampleDataItem, captions);
                        this.columns = this.generateColumns(sampleDataItem, captions);
                        this.schemaLoaded = true;
                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            generateModel(sampleDataItem, captions) {
                let model = {};
                let fields = {};

                for (var property in sampleDataItem) {
                    if (property.indexOf("registerEntryId") !== -1 || property.indexOf("RegisterEntryId") !== -1) {
                        model["id"] = property;
                    }

                    let lowerProperty = property.toLowerCase();
                    let label, labelEn;
                    if (captions.hasOwnProperty(lowerProperty)) {
                        if (captions[lowerProperty].hasOwnProperty('label')) {
                            label = captions[lowerProperty].label;
                        }

                        if (captions[lowerProperty].hasOwnProperty('labelEn')) {
                            labelEn = captions[lowerProperty].labelEn;
                        }
                    }

                    var propType = typeof sampleDataItem[property];
                    if (propType === "number") {
                        fields[property] = {
                            name: property,
                            type: "number",
                            label: label,
                            labelEn: labelEn,
                            visible: true
                        };
                        if (model.id === property) {
                            fields[property].editable = false;
                            fields[property].label = 'Id'
                            fields[property].labelEn = 'Id'
                        }
                    } else if (propType === "boolean") {
                        fields[property] = {
                            name: property,
                            type: "boolean",
                            label: label,
                            labelEn: labelEn,
                            visible: true
                        };
                    } else if (propType === "string") {
                        var parsedDate = kendo.parseDate(sampleDataItem[property]);
                        if (parsedDate) {
                            fields[property] = {
                                name: property,
                                type: "date",
                                label: label,
                                labelEn: labelEn,
                                visible: true
                            };
                            this.dateFields[property] = true;
                        } else {
                            fields[property] = {
                                name: property,
                                type: "string",
                                label: label,
                                labelEn: labelEn,
                                visible: true
                            };
                        }
                    }
                }

                model.fields = fields;
                return model;
            },
            generateColumns(sampleDataItem, captions) {
                let columns = [];
                for (var property in sampleDataItem) {
                    let lowerProperty = property.toLowerCase();
                    let title;
                    if (captions.hasOwnProperty(lowerProperty)
                        && captions[lowerProperty].hasOwnProperty('label')
                        && captions[lowerProperty].hasOwnProperty('labelEn')) {
                        title = this.isEnVersion ? captions[lowerProperty].labelEn : captions[lowerProperty].label;
                    } else {
                        title = property
                    }

                    let isIdField = property.indexOf("registerEntryId") !== -1 || property.indexOf("RegisterEntryId") !== -1;
                    if (isIdField) {
                        columns.push({
                            field: property,
                            width: 100,
                            title: "Id",
                            lockable: true,
                            locked: true
                        })
                        continue;
                    }
                    var propType = typeof sampleDataItem[property];
                    if (propType === "number") {
                        columns.push({
                            field: property,
                            title: title,
                            lockable: true,
                            width: 150,
                        })
                    } else if (propType === "boolean") {
                        columns.push({
                            field: property,
                            title: title,
                            template: this.booleanCellTemplate,
                            lockable: true,
                            width: 100,
                        })
                    } else if (propType === "string") {
                        var parsedDate = kendo.parseDate(sampleDataItem[property]);
                        if (parsedDate) {
                            columns.push({
                                field: property,
                                title: title,
                                format: '{0:' + this.dateFormat + '}',
                                lockable: true,
                                width: 200
                            })
                        } else {
                            columns.push({
                                field: property,
                                title: title,
                                lockable: true,
                                width: 200
                            })
                        }
                    } else {
                        columns.push({
                            field: property,
                            title: title,
                            lockable: true,
                            width: 200
                        })
                    }
                }

                return columns;
            },
            booleanCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            resize(componentName, size, grid) {
                this.$emit('resize', componentName, size, grid)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            archive(registerId, registerEntityId, registerName) {
                // Експорт на архив (JSON на модела на сибитие)
                this.$http.get(`/api/dynamicRegisters/archive`, { params: { registerId: registerId, registerEntityId: registerEntityId, registerName: registerName }, responseType: 'blob' }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'archive.txt');
                    document.body.appendChild(link);
                    link.click();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    });
                });
            }
        },
        mounted: function () {
            this.loadSchema()
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            }
        }
    }
</script>

<style scoped>
</style>
